export default __webpack_public_path__ + "static/media/ITER_project_ITA_9_Maggi_2021.15ecfd36.pdf";